export default __webpack_public_path__ + "static/media/ghibli.c2328a38.png";